export default __webpack_public_path__ + "static/media/steps-ball-green-checkd.b576555a.svg";